import { primaryColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const adminShortcutsStyle = () => ({
	logoWrapper: {
		'& img': {
			width: '65px',
			height: 'auto',
		},
	},
	container: {
		margin: '0px',
	},
	header: {
		margin: 16,
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
		'& button': {
			'min-width': '0',
		},
	},
	headingWrapper: {
		marginLeft: 16,
		marginBottom: 10,
		marginTop: 16,
	},
	inlineIcon: {
		height: 16,
		width: 16,
		objectFit: 'cover',
		marginRight: 8,
	},
	boxStyle: {
		display: 'flex',
		flexWrap: 'nowrap',
		'scrollbar-width': 'none',
		'-ms-overflow-style': 'none',
		overflowX: 'auto',
		'padding-left': '12px',
		'padding-right': '12px',
		'& > :not(style)': {
			flex: '0 0 auto',
			width: 160,
			'min-height': 128,
			margin: '0px 8px 22px 6px;',
		},
		'&::-webkit-scrollbar': {
			display: 'none',
		},
		'& > :last-child': {
			backgroundColor: primaryColor[0],
		},
		'& > :last-child svg path': {
			fill: 'white',
			'fill-opacity': 'unset',
		},
		'& > :last-child p': {
			color: whiteColor,
		},
	},
	linkWrapper: {
		margin: '6px 16px 60px 16px',
		textAlign: 'right',
	},
});

export default adminShortcutsStyle;
